import { render, staticRenderFns } from "./ManageFiscalObligationsTable.vue?vue&type=template&id=ec8309de&scoped=true&"
import script from "./ManageFiscalObligationsTable.vue?vue&type=script&lang=js&"
export * from "./ManageFiscalObligationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageFiscalObligationsTable.vue?vue&type=style&index=0&id=ec8309de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8309de",
  null
  
)

export default component.exports